import React from 'react'
import Browse from '../component/Browse'

const Movie = () => {
  return (
    <div>
      <Browse path="movie"/>
    </div>
  )
}

export default Movie